enum EClientType {
  INDIVIDUAL = 'INDIVIDUAL',
  COMPANY = 'COMPANY',
  BUDGET_COMPANY = 'BUDGET_COMPANY',
}

export default EClientType
